import { useState } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { RiMailSendLine } from "react-icons/ri";
import { FaPhoneAlt } from "react-icons/fa";
import { Button } from "flowbite-react";
import { FaArrowRightLong } from "react-icons/fa6";
import location_09 from "../../assets/images/location_09.svg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailRegex.test(email);
};

const validatePhoneNumber = (phoneNumber) => {
  const phoneRegex = /^[0-9]{10,15}$/;
  return phoneRegex.test(phoneNumber);
};

export default function FormInput() {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.address ||
      !formData.message
    ) {
      toast.error("Vui lòng điền đầy đủ thông tin!");
      return;
    }

    if (!validateEmail(formData.email)) {
      toast.error("Email không hợp lệ!");
      return;
    }

    if (!validatePhoneNumber(formData.phone)) {
      toast.error("Số điện thoại không hợp lệ!");
      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      toast.success("Gửi liên hệ thành công!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        address: "",
        message: "",
      });
    }, 5000);
  };

  return (
    <div className="w-full bg-[#e1f7ff] lg:px-[120px] lg:py-[40px] lg:mt-10 p-3">
      <div className="w-full flex container mx-auto p-3 flex-col gap-4 px-[16px] py-[32px] shadow-custom1 rounded-[16px] bg-white">
        <div>
          <p className="text-[24px] text-[#033F6A] font-semibold text-center">
            Hãy nói với chúng tôi
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="w-full flex flex-col gap-4 md:flex-row">
            <div className="flex flex-col gap-1 md:w-1/2 lg:w-1/2 w-full">
              <label className="text-[16px] font-medium text-black">
                Họ và tên
              </label>
              <div className="flex items-center border border-gray-300 rounded-md p-2 md:w-full lg:w-full">
                <AiOutlineUser className="text-gray-500 mr-2" />
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Họ và Tên"
                  className="flex-grow outline-none border-none"
                  required
                />
              </div>
            </div>
            <div className="flex flex-col gap-1 md:w-1/2 lg:w-1/2 w-full">
              <label className="text-[16px] font-medium text-black">
                Địa chỉ email
              </label>
              <div className="flex items-center border border-gray-300 rounded-md p-2 md:w-full lg:w-full">
                <RiMailSendLine className="text-gray-500 mr-2" />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email của bạn"
                  className="flex-grow outline-none border-none"
                  required
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4 md:mt-4 lg:mt-4  md:flex-row w-full">
            <div className="flex flex-col gap-1 md:w-1/2 lg:w-1/2 w-full mt-4">
              <label className="text-[16px] font-medium text-black">
                Số điện thoại
              </label>
              <div className="flex w-full items-center border border-gray-300 rounded-md p-2 md:w-full lg:w-full">
                <FaPhoneAlt className="text-gray-500 mr-2" />
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Số điện thoại của bạn"
                  className="flex-grow outline-none border-none"
                  required
                />
              </div>
            </div>
            <div className="flex flex-col gap-1 md:w-1/2 lg:w-1/2 w-full md:mt-4">
              <label className="text-[16px] font-medium text-black">
                Địa chỉ
              </label>
              <div className="flex w-full items-center border border-gray-300 rounded-md p-2 md:w-full lg:w-full">
                <img
                  src={location_09}
                  alt="loca"
                  className="text-gray-500 mr-2"
                />
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Nhập địa chỉ của bạn"
                  className="flex-grow outline-none border-none"
                  required
                />
              </div>
            </div>
          </div>
          <div className="w-full flex flex-col gap-1 md:mt-4 lg:mt-4 mt-4">
            <label>Lời nhắn</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Vui lòng để lại lời nhắn cho chúng tôi"
              className="text-gray-500 w-full h-[128px] px-[16px] py-[16px] border border-[#E2E2E2] rounded-[16px]"
              required
            ></textarea>
          </div>
          <div className="md:flex md:items-center md:justify-center mt-3 md:mt-4">
            <Button
              type="submit"
              className="flex items-center justify-center gap-5 bg-[#27C6FF] w-full h-[54px] hover:bg-green-500 hover:text-white rounded-[30px] md:w-[171px] lg:w-[171px]"
              disabled={isLoading}
            >
              <div className="flex items-center gap-3 ">
                {isLoading ? (
                  <span className="animate-spin h-5 w-5 border-4 border-t-4 border-white border-solid rounded-full" />
                ) : (
                  <p className="text-[16px] font-normal">Gửi liên hệ</p>
                )}
                <FaArrowRightLong />
              </div>
            </Button>
          </div>
        </form>
      </div>

      {/* Toast notifications */}
      <ToastContainer />
    </div>
  );
}
